import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { Form, GeneralTextFieldForm } from '../../../../custom-components'
import { vendorEvaluationForms } from '../../../../constants'
import { createVendorEvaluation } from '../../../../api/smartbestbuys-api'
import { useContext } from 'react'
import { RootContext } from '../../../..'

interface IVendorEvaluationAnswer {
  sequence: number
  topic: string
  score: number
  weight: number
}

interface VendorEvalutationDialogFromValues {
  formId: number
  answers: IVendorEvaluationAnswer[]
  remark?: string
}

interface Props extends DialogProps {
  vendorId: number
  onComplete: () => void
}

const defautlFormId = 1

const VendorEvaluationCreateDialog: React.FC<Props> = (props: Props) => {
  const { vendorId, onComplete, onClose, ...otherProps } = props
  const { triggerSnackbar } = useContext(RootContext)

  // note: if form id is dynamic then do useMemo
  const evaluationForm = vendorEvaluationForms[defautlFormId]

  const {
    control,
    formState: { isSubmitting, errors },
    handleSubmit,
    reset,
    setError,
    clearErrors,
  } = useForm<VendorEvalutationDialogFromValues>({
    defaultValues: {
      formId: defautlFormId,
      answers: evaluationForm.questions.map((data) => ({
        sequence: data.sequence,
        topic: data.topic,
        score: 0,
        weight: data.weight,
      })),
      remark: '',
    },
  })

  const handleSubmitQuotationPartialUpdateForm = async (values: VendorEvalutationDialogFromValues) => {
    const isAnswerEveryQuestion = values.answers.every((a) => a.score)

    if (!isAnswerEveryQuestion) {
      setError('answers', {
        type: 'required',
        message: 'กรุณาตอบให้ครบทุกคำถาม',
      })
    } else {
      if (!!errors.answers) {
        clearErrors('answers')
      }

      const response = await createVendorEvaluation(vendorId, {
        formAnswer: {
          formId: values.formId,
          answers: values.answers.map((answer) => {
            return { topic: answer.topic, score: answer.score, weight: answer.weight }
          }),
        },
        remark: values.remark,
      })

      if (response?.status === 201) {
        triggerSnackbar('ประเมินผู้ขายสำเร็จ')
        if (!!onComplete) onComplete()
        reset()
      } else {
        triggerSnackbar('ประเมินผู้ขายไม่สำเร็จ')
        if (!!onClose) onClose({}, 'escapeKeyDown')
      }
    }
  }

  return (
    <Dialog fullWidth maxWidth="md" {...otherProps} className="p-4">
      <Form onSubmit={handleSubmit(handleSubmitQuotationPartialUpdateForm)}>
        <DialogTitle>
          <div className="text-4xl">ประเมินผู้ขาย</div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Table>
                <TableHead>
                  <TableRow>
                    <Box bgcolor="primary.dark" clone>
                      <TableCell align="left" style={{ color: 'white' }}>
                        หัวข้อประเมิน
                      </TableCell>
                    </Box>
                    <Box bgcolor="primary.dark" clone>
                      <TableCell align="left" style={{ color: 'white' }}>
                        คำอธิบาย
                      </TableCell>
                    </Box>
                    <Box bgcolor="primary.dark" clone>
                      <TableCell align="center" style={{ color: 'white' }}>
                        คะแนนเต็ม (%)
                      </TableCell>
                    </Box>
                    <Box bgcolor="primary.dark" clone>
                      <TableCell align="center" style={{ color: 'white' }}>
                        คะแนนที่ได้ เต็ม 10
                      </TableCell>
                    </Box>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {evaluationForm.questions.map((evaluation, index) => (
                    <TableRow>
                      <TableCell align="left">{evaluation.topic}</TableCell>
                      <TableCell align="left">
                        {evaluation.detail.map((detail) => (
                          <div>- {detail}</div>
                        ))}
                      </TableCell>
                      <TableCell align="center">{evaluation.weight}</TableCell>
                      <TableCell align="center">
                        <GeneralTextFieldForm
                          key={`answers.${index}.score`}
                          margin="none"
                          control={control}
                          name={`answers.${index}.score`}
                          rules={{
                            required: true,
                            max: {
                              value: 10,
                              message: 'คะแนนสูงสุดอยู่ที่ 10 คะแนน',
                            },
                            min: {
                              value: 1,
                              message: 'คะแนนต่ำสุดอยู่ที่ 1 คะแนน',
                            },
                          }}
                          onPostChange={() => {
                            if (!!errors.answers) {
                              clearErrors('answers')
                            }
                          }}
                          type="number"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>
            <Grid item xs={12} md={6}>
              <GeneralTextFieldForm name="remark" label="หมายเหตุ (ถ้ามี)" control={control} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="button" color="primary" onClick={() => onClose && onClose({}, 'escapeKeyDown')}>
            ปิด
          </Button>
          <Button type="submit" color="primary" variant="contained" disabled={isSubmitting}>
            บันทึก
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}

export default VendorEvaluationCreateDialog
